"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaysteDisposalSiteSchema = void 0;
const transport_types_1 = require("@alliance-disposal/transport-types");
exports.WaysteDisposalSiteSchema = {
    name: 'wayste-disposal-site',
    alias: 'Wayste Disposal Site',
    shortName: 'Disposal Site',
    applications: ['wayste'],
    returnType: {
        wayste: transport_types_1.DisposalSite.DisposalSiteTransport,
    },
    searchableAttributes: [
        {
            field: 'name',
            alias: 'Disposal Site Name',
            shortName: 'disposal_site_name',
            searchableByDefault: true,
        },
        {
            field: 'address.addressLine1',
            alias: 'Address Line 1',
            shortName: 'disposal_site_address',
            searchableByDefault: true,
        },
        {
            field: 'address.city',
            alias: 'City',
            shortName: 'disposal_site_city',
            searchableByDefault: true,
        },
        {
            field: 'address.state',
            alias: 'State',
            shortName: 'disposal_site_state',
            searchableByDefault: false,
        },
        {
            field: 'address.zip',
            alias: 'Zip',
            shortName: 'disposal_site_zip',
            searchableByDefault: false,
        },
    ],
    filterableAttributes: [],
    extraMappings: [],
};
//# sourceMappingURL=wayste-disposal-site.js.map